// import external dependencies
import "jquery";

// Import everything from autoload
;

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// import then needed Font Awesome functionality
import { library, dom } from "@fortawesome/fontawesome-svg-core";

// import social icons
import {
  faFacebook,
  faInstagram,
  faTripadvisor,
  faHotjar,
} from "@fortawesome/free-brands-svg-icons";

// add the imported icons to the library
library.add(faFacebook, faTripadvisor, faInstagram, faHotjar);

// import other icons
import {
  faShoppingCart,
  faPhone,
  faMapMarkerAlt,
  faClock,
  faShippingFast,
} from "@fortawesome/free-solid-svg-icons";

// add the imported icons to the library
library.add(faShoppingCart, faPhone, faMapMarkerAlt, faClock, faShippingFast);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

// Check for click events on the navbar burger icon
$(".navbar-burger").click(function () {
  // Toggle the 'is-active' class on both the 'navbar-burger' and the 'navbar-menu'
  $(".navbar-burger").toggleClass("is-active");
  $(".navbar-menu").toggleClass("is-active");
});

$(document).ready(function () {
  if ($(window).width() <= 768) {
    $("video").remove();
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js